/**
 * Ashtakavarga via VedAstro's `SarvashtakavargaChart` — one call returns the
 * Bhinnashtakavarga bindu rows (per sign, Aries → Pisces) for the seven
 * classical grahas plus the Ascendant, and the summed Sarvashtakavarga row.
 */

import { callMethod, buildTime, SIGN_ORDER } from './vedastro.js'
import { memoized } from './kundliData.js'

export const SAV_PLANETS = ['Sun', 'Moon', 'Mars', 'Mercury', 'Jupiter', 'Venus', 'Saturn']

function normalizeRow(entry) {
  return {
    total: Number(entry?.Total) || 0,
    rows: Array.isArray(entry?.Rows) ? entry.Rows.map((n) => Number(n) || 0) : Array(12).fill(0),
  }
}

/**
 * Returns `{ planets: { Sun: { total, rows[12] }, … }, ascendant, sav }`
 * where `sav` is the per-sign Sarvashtakavarga total (the strength map used
 * for transit judgement). Row index 0 = Aries … 11 = Pisces (SIGN_ORDER).
 */
export async function getSarvashtakavarga({ dob, tob, location }, signal) {
  return memoized(`sav|${dob}|${tob}|${location?.Name}`, async () => {
    const birthTime = buildTime(dob, tob, location)
    const chart = await callMethod('SarvashtakavargaChart', { birthTime }, signal)
    const planets = {}
    for (const p of SAV_PLANETS) planets[p] = normalizeRow(chart?.[p])
    let sav = chart?.Sarvashtakavarga ? normalizeRow(chart.Sarvashtakavarga) : null
    if (!sav) {
      // Older payloads may omit the total row — sum the seven grahas.
      const rows = SIGN_ORDER.map((_, i) => SAV_PLANETS.reduce((a, p) => a + planets[p].rows[i], 0))
      sav = { total: rows.reduce((a, b) => a + b, 0), rows }
    }
    return {
      planets,
      ascendant: chart?.Ascendant ? normalizeRow(chart.Ascendant) : null,
      sav,
    }
  })
}
